<template>
  <div v-if="showDeliverSection">
    <el-row :gutter="24">
      <!--  -->
      <el-col :span="6">
        <el-form-item label="投送人姓名" prop="delivererName">
          <el-input
            v-model="baseData.delivererName"
            placeholder="请输入"
            clearable
            maxlength="32"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="投送人电话" prop="delivererPhone">
          <el-input
            v-model="baseData.delivererPhone"
            placeholder="请输入"
            clearable
            maxlength="32"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="投送人身份证号" prop="delivererIdNo">
          <el-input
            v-model="baseData.delivererIdNo"
            placeholder="请输入身份证号"
            clearable
            maxlength="32"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <!-- <TimeRangePicker startLabel="投送人身份证期限" endLabel="至" startProp="delivererIdDurationStart"
        endProp="delivererIdDurationEnd" :startDate="baseData.delivererIdDurationStart"
        :endDate="baseData.delivererIdDurationEnd" @startDateChange="startDateChange" @endDateChange="endDateChange">
      </TimeRangePicker> -->
      <el-row :gutter="12">
        <el-col :span="6">
          <el-form-item label="投送人身份证期限" prop="delivererIdDurationStart">
            <el-date-picker
              v-model="baseData.delivererIdDurationStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请输入"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="至" prop="delivererIdDurationEnd">
            <el-date-picker
              v-model="baseData.delivererIdDurationEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="请输入"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col :span="12">
        <el-form-item label="投送人地址" prop="delivererAddress">
          <el-input
            v-model="baseData.delivererAddress"
            placeholder="请输入地址"
            clearable
            maxlength="32"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'DeliverInfo',
    data() {
      return {};
    },
    mounted: () => {
      console.log('deliverSectionMounted');
    },
    props: ['showDeliverSection', 'baseData'],
    methods: {
      startDateChange(val) {
        console.log(val);
      },
      endDateChange(val) {
        console.log(val);
      },
    },
  };
</script>
